var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar-s",attrs:{"src":_vm.logoSrc},on:{"error":_vm.imgUrlAlt}})}
var staticRenderFns = []
export { render, staticRenderFns }